/**
 * Copyright © Veeam Software Group GmbH.
 */

import { JobSessionTaskStatusRepresentation as JobSessionTaskStatuses } from '@veeam-vspc/models/web-controllers';

export type JobSessionTaskStatusRepresentation = JobSessionTaskStatuses;
export const JobSessionTaskStatusRepresentation = JobSessionTaskStatuses;
